
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSnowShowersPolartwilight as ObiLightningSnowShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-snow-showers-polartwilight.js';
 
 
 

 
 export const ObiLightningSnowShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-lightning-snow-showers-polartwilight',
   elementClass: ObiLightningSnowShowersPolartwilightElement,
   events: {
     
   }
  });
 
 